import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// Material
import Button from "@material-ui/core/Button";

// Assets
import mainImage from "../../assets/backgrounds/getConnectedPage/getConnectedHero.png";
import elipse from "../../assets/backgrounds/elipse.svg";

// Components
import Section from "../../components/Section/Section";
import Text, { types } from "../../components/Text/Text";
import LinkScroll from "../../components/LinkScroll/LinkScroll";
import urls from "../../config/urls";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: "280px",
    paddingBottom: "90px",
    background:
      "transparent linear-gradient(109deg, #3ACCE1 0%, #1CAFC4 100%) 0% 0% no-repeat padding-box",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: "0",
    gap: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      gap: "5vw",
      paddingTop: "180px"
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      gap: 0,
      padding: "102px 12px 32px"
    },

    [`&:after`]: {
      [theme.breakpoints.up(1440)]: {
        content: '""',
        position: "absolute",
        top: "20%",
        right: "unset",
        left: "0",
        height: 300,
        width: 150,
        filter: "saturate(0) brightness(2)",
        backgroundImage: `url(${elipse})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "contain",
        transform: "translateY(25%)",
        zIndex: "99"
      },
      [theme.breakpoints.down("md")]: {
        left: "unset",
        right: "93vw",
        height: 250,
        width: 125
      },
      [theme.breakpoints.down(1440)]: {
        height: 200,
        width: 100,
        left: "0",
        right: "unset"
      }
    }
  },
  textWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(3)
    },
    [theme.breakpoints.down("sm")]: {
      gap: 0
    }
  },
  heading: {
    color: "#fff",
    fontSize: "26px",
    width: "22ch",
    [theme.breakpoints.down("md")]: {
      fontSize: "22px"
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      width: "100%",
      fontSize: "18px",
      marginBottom: theme.spacing(2)
    }
  },
  title: {
    color: "#fff",
    maxWidth: "10ch",
    fontSize: "56px",
    margin: "0",
    [theme.breakpoints.down("md")]: {
      fontSize: 48
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      width: "100%",
      maxWidth: "100%",
      fontSize: "30px",
      marginBottom: theme.spacing(4)
    }
  },
  image: {
    // transform: " translateY(8%)",
    width: "1120px",
    [theme.breakpoints.down("md")]: {
      width: "900px"
    },
    [theme.breakpoints.down(1440)]: {
      width: "700px"
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "500px",
      marginBottom: "32px"
    }
  },
  button: {
    fontFamily: "Montserrat Black",
    textTransform: "none",
    fontSize: "24px",
    padding: "28px 124px",
    borderRadius: "10px",
    boxShadow: "0px 3px 66px #00000029",
    backgroundColor: "#0B4283",
    color: "#fff",
    lineHeight: 1,
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
      padding: "24px 90px"
    },
    [theme.breakpoints.down(1440)]: {
      // fontSize: "14px",
      // marginBottom: theme.spacing(4),
      // padding: "24px 70px"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginBottom: theme.spacing(4),
      padding: "24px 0",
      width: "100%",
      height: "70px"
    }
  }
}));

const GetConnectedHero = () => {
  const classes = useStyles();

  return (
    <Section isMain className={classes.root}>
      <div className={classes.textWrapper}>
        <Text type={types.homeSectionHeading} className={classes.heading}>
          Empower our users to share their evidence with you
        </Text>
        <Text type={types.homeSectionTitle} className={classes.title}>
          Get your organisation connected
        </Text>
        <Button
          className={classes.button}
          color="secondary"
          variant="contained"
          disableElevation
          component={LinkScroll}
          to={`${urls.getConnected}#demo`}
        >
          Book a demo
        </Button>
      </div>
      <div className={classes.imageWrapper}>
        <img src={mainImage} className={classes.image} alt="Get connected" />
      </div>
    </Section>
  );
};

export default GetConnectedHero;
